export const PortalIdList = ['shops', 'schools', 'hospitals']
